import {LAYER_BACKGROUND_ID, LAYER_BACKGROUND_SOURCE} from '../mapbox-constants/mapbox_constants';

const layerBackground = (mapConfig) => {
  return {
    id: LAYER_BACKGROUND_ID,
    source: LAYER_BACKGROUND_SOURCE,
    type: 'raster',
    paint: {
      'raster-opacity': 1,
      'raster-fade-duration': 1,
    },
    minzoom: mapConfig.ZOOM_MIN_SECTIONS,
  };
};

export default {layerBackground};
